var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.menus[3])?_c('div',{attrs:{"id":"statement"},domProps:{"innerHTML":_vm._s(_vm.menus[3].menuText)}},[_vm._v(" 项目介绍 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }